module.exports = __webpack_public_path__ + "static/media/marks-card-bg.ddc63875.png";